import { computed, Computed, Action, action } from "easy-peasy";

import { Authorization } from "../types";

import { StoreMaker } from "./storeTypes";

export interface AuthStore {
  authorized: Computed<AuthStore, boolean>;

  tokens?: Authorization;
  setTokens: Action<AuthStore, Authorization>;
}

const makeAuthStore: StoreMaker<AuthStore> = (defaultValues) => ({
  authorized: computed((state) => !!state.tokens),

  tokens: defaultValues?.tokens ?? undefined,
  setTokens: action((state, payload) => {
    state.tokens = payload;
  }),
});

export default makeAuthStore;
